import { useMutation } from "@tanstack/react-query";
import { uploadManagedFile } from "@/utils/managedFile";

interface ManagedFile {
  id: string;
  original_filename: string;
  content_type: string;
  size_bytes: number | null;
  url: string | null;
}

export function useUploadFile() {
  return useMutation({
    mutationFn: (file: File): Promise<ManagedFile> => uploadManagedFile<ManagedFile>(file),
  });
}
